import {ModellingTheBrain} from './Posts/ModellingTheBrain';

export const allPosts: any = [{
    title: 'Modelling The Brain',
    date: '11th August 2020',
    href: '/brain',
    content: ModellingTheBrain()
}];
